import Toggle from 'emerald-ui/lib/Toggle';
import populateDocs from './utils/populateDocs';

export default {
  ...populateDocs([{ component: Toggle, componentName: 'Toggle' }], 'Toggle'),
  description:
    'A switch like component to toggle between an "on" and "off" state. Note that you can access the current checked state of an uncontrolled Toggle via a ref with the <pre>checked</pre> property.',
  codeSamples: [
    {
      title: 'Default',
      scope: { Toggle },
      whiteBackground: true,
      code: `<Toggle label="toggle" />`,
    },
  ],
};
